import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import FormControl from '@material-ui/core/FormControl'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import HelpIcon from '@material-ui/icons/Help'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import { DarkCustomExpansionPanelActions } from '../custom-material/expansion-panel/ExpansionPanelActions'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import CustomFormControlLabel from '../custom-material/form-control-label/FormControlLabel'
import { SmallCustomSwitch } from '../custom-material/switch/Switch'
import { TitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import CustomTypography from '../custom-material/typography/Typography'
import EmptyStateComponent from '../common/empty-state/EmptyStateComponent'
import SuspendAllDialog from './SuspendAllDialog'
import { isEmpty } from 'lodash'
import PagedDialogComponent from '../common/PagedDialogComponent'

const styles = theme => ({
  expansionPanelTitle: {
    fontSize: 22,
    fontWeight: 'normal',
    paddingRight: 0,
    display: 'flex',
    alignItems: 'center'
  },
  expansionPanelActions: {},
  formControlLabel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 4
  },
  disabledSwitch: {
    backgroundColor: '#C0C0C0 !important'
  },
  helpIcon: {
    marginLeft: 6,
    fontSize: 22,
    color: '#00ACEF'
  },
  hr: {
    borderColor: '#1A305A'
  }
})

class PublicationSettingsExpansionPanel extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      suspendAllDialogOpen: false,
      helpDialogOpen: false
    }

    this.openSuspendAllDialog = () => this.setState({suspendAllDialogOpen: true})
    this.handleCloseSuspendAllDialog = () => this.setState({suspendAllDialogOpen: false})
    this.openHelpDialog = (event) => { event.stopPropagation(); this.setState({helpDialogOpen: true}) }
    this.handleCloseHelpDialog = () => this.setState({helpDialogOpen: false})
  }

  render () {
    const {
      classes,
      exclusions,
      toggleFilterPreferred,
      enableSuspendAll,
      disableSuspendAll,
      isAllPublicationsSuspended,
      contact,
      showFirstTimeHelp,
      dismissFirstTimeHelp
    } = this.props
    const { suspendAllDialogOpen, helpDialogOpen } = this.state

    return (
      <CustomExpansionPanel defaultExpanded>
        <TitleCustomExpansionPanelSummary expandIcon={<ArrowRightIcon style={{fontSize: 50}} />}>
          <CustomTypography className={classes.expansionPanelTitle}>
            Custom Email Preference Settings
            <HelpIcon className={classes.helpIcon} onClick={this.openHelpDialog} />
          </CustomTypography>
        </TitleCustomExpansionPanelSummary>
        <CustomExpansionPanelDetails style={{paddingTop: 16, paddingBottom: 16}}>
          {isEmpty(exclusions)
            ? <EmptyStateComponent title='No Publication Settings found' />
            : <React.Fragment>
              <FormControl component='fieldset' className={classes.formControl}>
                <CustomFormControlLabel
                  label={<span className={classes.formControlLabel}>Send all publications (includes favorited drugs)</span>}
                  control={
                    <SmallCustomSwitch
                      disableRipple
                      classes={{track: isAllPublicationsSuspended ? classes.disabledSwitch : ''}}
                      checked={exclusions.filter_preferred === false}
                      onChange={toggleFilterPreferred}
                      disabled={isAllPublicationsSuspended}
                    />
                  }
                />
                <hr className={classes.hr} />
                <CustomFormControlLabel
                  label={<span className={classes.formControlLabel}>Send publications for only favorited drugs and saved preferences below</span>}
                  control={
                    <SmallCustomSwitch
                      disableRipple
                      classes={{track: isAllPublicationsSuspended ? classes.disabledSwitch : ''}}
                      checked={exclusions.filter_preferred === true}
                      onChange={toggleFilterPreferred}
                      disabled={isAllPublicationsSuspended}
                    />
                  }
                />
              </FormControl>
            </React.Fragment>
          }
        </CustomExpansionPanelDetails>
        <DarkCustomExpansionPanelActions className={classes.expansionPanelActions}>
          <FormControl component='fieldset' className={classes.formControl}>
            <CustomFormControlLabel
              label={<span className={classes.formControlLabel}>Suspend ALL Real-Time Insight Publications</span>}
              control={
                <SmallCustomSwitch
                  disableRipple
                  checked={isAllPublicationsSuspended}
                  onChange={isAllPublicationsSuspended ? disableSuspendAll('other') : this.openSuspendAllDialog}
                />
              }
            />
          </FormControl>
          {suspendAllDialogOpen
            ? <SuspendAllDialog
              dialogOpen={suspendAllDialogOpen}
              handleCloseDialog={this.handleCloseSuspendAllDialog}
              suspendAll={enableSuspendAll}
              sectionName='Publications'
              type='other'
            />
            : null
          }
          {helpDialogOpen || showFirstTimeHelp
            ? <PagedDialogComponent dialogOpen={helpDialogOpen || showFirstTimeHelp}
              handleCloseDialog={showFirstTimeHelp ? dismissFirstTimeHelp : this.handleCloseHelpDialog}
              emailButtonText='Set up a training!' emailSubject='Email Preferences Training'
              emailBody={`I am interested in learning more about Email Preferences. Please contact me with more information.\n\nThanks!`}
              contact={contact}
              brochurePath={{path: 'Email Preferences/IPDAnalytics_EmailPreferencesGuide.pdf', text: 'Download guide and topic definitions!'}}
              items={[...Array(5).keys()].map(i => `Email Preferences/EmailPreferencesOnPagePopupImage${i + 1}.png`)}>
              {(item, classes) => (
                <img className={classes.learnMoreImage} src={`/learn-more-images/${item}`} alt='Learn More' />
              )}
            </PagedDialogComponent>
            : null
          }
        </DarkCustomExpansionPanelActions>
      </CustomExpansionPanel>
    )
  }
}

PublicationSettingsExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  exclusions: PropTypes.object,
  toggleFilterPreferred: PropTypes.func.isRequired,
  enableSuspendAll: PropTypes.func.isRequired,
  disableSuspendAll: PropTypes.func.isRequired,
  isAllPublicationsSuspended: PropTypes.bool,
  contact: PropTypes.object,
  showFirstTimeHelp: PropTypes.bool.isRequired,
  dismissFirstTimeHelp: PropTypes.func.isRequired
}

export default withStyles(styles)(PublicationSettingsExpansionPanel)
